import React, { useState } from "react";
import Faq from "./FAQ"; // Імпортуємо компонент Faq
import styles from "./FAQBlockMini.module.scss";
import { Link } from "react-router-dom";

interface FaqData {
  question: string;
  answer: string;
}

interface FaqBlockProps {
  faqData: FaqData[]; // Передаємо дані через пропс
}

const FaqBlock: React.FC<FaqBlockProps> = ({ faqData }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null); // Стан для збереження відкритого питання

  const handleToggle = (index: number) => {
    // Якщо клікнули на відкрите питання, закриваємо його, інакше відкриваємо нове
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container section">
      <div className={`sectionContainer sectionContainerWhite bigSection`}>
        <div className="sideP64 sectionTitle sectionTitleButton">
          <h2>Häufige Fragen</h2>
          <Link to="/faq/" className={styles.buttonLink}>
            <button className="commonButton buttonMd buttonWhiteBg">
              Alle Fragen und Antworten
            </button>
          </Link>
        </div>
        <div className="sideP64 top30">
          {faqData.map((faq, index) => (
            <Faq
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index} // Передаємо чи питання відкрите
              onToggle={() => handleToggle(index)} // Передаємо функцію для відкриття/закриття
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqBlock;
